export default {
    label_task:{
        en:"Territories Business plan 3years",
        bn:'Variety Report'
    },
    label_pocket_market :{
        en:"Pocket Market",
        bn:'ব্যবহারকারীরা'
    },
    label_territory_recommendation :{
        en:"Territory Recommendation",
        bn:'ব্যবহারকারীরা'
    },
    label_manager_recommendation :{
        en:"Managers Recommendation",
        bn:'ব্যবহারকারীরা'
    },
    label_manager_suggestion :{
        en:"Managers Suggestion",
        bn:'ব্যবহারকারীরা'
    },
    label_forecast :{
        en:"Forecast",
        bn:'ব্যবহারকারীরা'
    },
    label_dealer_meeting :{
        en:"# of Dealer Meeting ",
        bn:'ব্যবহারকারীরা'
    },
    label_farmer_meeting :{
        en:"# of Farmer Meeting",
        bn:'ব্যবহারকারীরা'
    },
    label_num_demo :{
        en:"# of Demo",
        bn:'ব্যবহারকারীরা'
    },
    label_num_result_sharing :{
        en:"# of Result Sharing",
        bn:'ব্যবহারকারীরা'
    },
    label_num_field_day :{
        en:"# of Field Day",
        bn:'ব্যবহারকারীরা'
    },
}